export const useDomain = () => {
    const params = new URLSearchParams(window.location.search)
    const domainFromParam = params.get('domain') || 'gssnhr.com'
    const aliases: Record<string, string> = {}

    const resolvedDomain =
        aliases[window.location.hostname] || window.location.hostname

    return window.location.hostname === 'localhost'
        ? domainFromParam
        : resolvedDomain
}
